import { useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet.jsx';
import { Button } from '@/components/ui/button.jsx';
import { toast } from '@/components/ui/toaster.jsx';
import { api } from '@/lib/api.js';
import { ymdFromNow } from '@/lib/date-display.js';

export default function ManualTaskSheet({ open, onOpenChange, onSuccess }) {
  const defaultDue = ymdFromNow(3);
  const [subject, setSubject] = useState('');
  const [dueDate, setDueDate] = useState(defaultDue);
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit() {
    if (!subject.trim()) {
      toast.error('Subject is required');
      return;
    }

    setSubmitting(true);
    try {
      await api.post('/api/tracon/command-center/tasks', {
        subject: subject.trim(),
        due_date: dueDate,
        notes: notes.trim() || null,
      });
      toast.success('Task created');
      setSubject('');
      setNotes('');
      setDueDate(ymdFromNow(3));
      onSuccess?.();
    } catch (err) {
      toast.error(`Failed: ${err.message || 'unknown error'}`);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-lg overflow-y-auto">
        <SheetHeader>
          <SheetTitle>New manual task</SheetTitle>
          <SheetDescription>Create a reminder or to-do that appears in Traffic Pattern</SheetDescription>
        </SheetHeader>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-medium text-text-muted">Subject *</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="What needs to be done?"
              className="mt-1 w-full rounded border border-border bg-bg px-3 py-2 text-sm text-text placeholder:text-text-dim"
              autoFocus
            />
          </div>

          <div>
            <label className="text-xs font-medium text-text-muted">Due date *</label>
            <input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              className="mt-1 w-full rounded border border-border bg-bg px-3 py-2 text-sm text-text"
            />
          </div>

          <div>
            <label className="text-xs font-medium text-text-muted">Notes</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={3}
              placeholder="Additional context…"
              className="mt-1 w-full rounded border border-border bg-bg px-3 py-2 text-sm text-text placeholder:text-text-dim"
            />
          </div>

          <Button onClick={handleSubmit} disabled={submitting} className="w-full">
            {submitting ? 'Creating…' : 'Create task'}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
